module.exports = __webpack_public_path__ + "img/gamefocus.503f75e.jpg";